<template>
  <div>
    <el-row>
      <el-col :span="24">
        <img class="logo" src="@/assets/logo.png" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
  .front {
    .el-header .logo {
      width: auto;
      height: 50px;
    }

    .title {
      color: white;
      text-align: center;
      font-size: 13px;
      margin-top: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/front/Header.vue